import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ['stopLoader', 'switchLoader']

    connect() {
        this.element.classList.remove('hidden')
    }

    stop(event) {
        event.currentTarget.classList.add('hidden')
        this.stopLoaderTarget.classList.remove('hidden')

        axios.delete('/alias')
        .then(() => {
            location.reload()
        })
        .catch(error => {
            console.log(error)

            alert('Something went wrong!')
        })
    }

    switch(event) {
        var pi = prompt('Please enter PI', '')

        if (pi) {
            event.currentTarget.classList.add('hidden')
            this.switchLoaderTarget.classList.remove('hidden')

            axios.post('/alias', {
                pi: pi
            })
            .then(() => {
                location.reload()
            })
            .catch(error => {
                console.log(error)

                alert('Something went wrong!')
            })
        }
    }
}
